<template>
  <div>
    <BaseCard
      :title="localStorage.translations.pages['sales_project']
        [type === 'responsible' ? 'planned_resources-responsible_employees' : 'planned_resources-subscribers']
        [type === 'responsible' ? 'main' : 'title']"
      class-body="d-grid gap-5"
    >
      <div v-if="showItems.length" class="d-flex flex-wrap gap-2">
        <ProjectPlannedResourcesResponsibleAndSubscribersWrapItem
          v-for="(item, index) in showItems"
          :key="'roles' + index"
          :item="item"
          :edit="edit"
          :type="type"
        />
      </div>
      <div v-else class="f16 secondary--text fw500">
        {{ localStorage.translations.pages.common.text['net-dannyh'] }}
      </div>
      <ProjectPlannedResourcesResponsibleAndSubscribersAddModal
        v-if=" edit && $userCheckAccess({abilities: type === 'responsible'
          ? 'edit_project_responsible' : 'edit_project_subscribers'})"
        :projectId="$route.params.id"
        :type="type"
      />
    </BaseCard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectPlannedResourcesResponsibleAndSubscribersAddModal from './ProjectPlannedResourcesResponsibleAndSubscribersAddModal'
import ProjectPlannedResourcesResponsibleAndSubscribersWrapItem from './ProjectPlannedResourcesResponsibleAndSubscribersWrapItem'
import BaseCard from "components/base/BaseCard";

export default {
  name: 'ProjectPlannedResourcesResponsibleAndSubscribersWrap',
  props: {
    edit: Boolean,
    createContinue: Boolean,
    type: String,
  },
  components: {
    BaseCard,
    ProjectPlannedResourcesResponsibleAndSubscribersAddModal,
    ProjectPlannedResourcesResponsibleAndSubscribersWrapItem,
  },
  computed: {
    ...mapGetters('workClientProjectsResponsibleEmployees', [
      'workClientProjectsResponsibleEmployeesAll_project',
    ]),
    ...mapGetters('workClientProjectsSubscribers', ['workClientProjectsSubscribersAll_project']),
    showItems() {
      return this.type === 'responsible'
        ? this.workClientProjectsResponsibleEmployeesAll_project
        : this.workClientProjectsSubscribersAll_project
    },
  },
}
</script>
